/**
 * 环境配置
 * 根据构建时的环境变量自动选择对应的配置
 * 
 * Vue CLI 的 --mode 参数会加载对应的 .env.* 文件：
 * - --mode test 会加载 .env.test
 * - --mode production 会加载 .env.production
 * 
 * 环境变量必须以 VUE_APP_ 开头才能在客户端代码中访问
 */

// 环境配置映射（默认值）
const defaultConfig = {
  test: {
    baseUrl: 'http://59.110.230.109:9003/sun-wxt',
    appId: 'wxe3d25b8faf11a4e0'
  },
  production: {
    baseUrl: 'https://applets.greatwm.com/sun-wxt',
    appId: 'wxdf8c995dbaf386bc'
  },
  development: {
    baseUrl: 'http://localhost:9003/sun-wxt',
    appId: 'wxe3d25b8faf11a4e0'
  }
}

// 判断当前环境
// 优先级：VUE_APP_ENV > 通过 baseUrl 判断 > 默认 production
let currentEnv = 'production'

if (process.env.VUE_APP_ENV) {
  // 如果设置了 VUE_APP_ENV，直接使用
  currentEnv = process.env.VUE_APP_ENV
} else if (process.env.VUE_APP_BASE_URL) {
  // 如果设置了 VUE_APP_BASE_URL，通过 URL 判断环境
  const baseUrl = process.env.VUE_APP_BASE_URL
  if (baseUrl.includes('59.110.230.109') || baseUrl.includes('test')) {
    currentEnv = 'test'
  } else if (baseUrl.includes('applets.greatwm.com') || baseUrl.includes('production')) {
    currentEnv = 'production'
  }
} else if (process.env.NODE_ENV === 'development') {
  currentEnv = 'development'
}

// 获取当前环境的默认配置
const defaultEnvConfig = defaultConfig[currentEnv] || defaultConfig.production

// 从环境变量获取配置，如果没有则使用默认值
const currentConfig = {
  baseUrl: process.env.VUE_APP_BASE_URL || defaultEnvConfig.baseUrl,
  appId: process.env.VUE_APP_WX_APPID || defaultEnvConfig.appId,
  env: currentEnv
}

// 开发环境下输出配置信息（便于调试）
if (process.env.NODE_ENV === 'development') {
  console.log('当前环境配置:', currentConfig)
}
// 导出配置
export default {
  ...currentConfig,
  // 是否开发环境
  isDev: process.env.NODE_ENV === 'development',
  // 当前环境
  currentEnv: currentEnv
}

// 导出 baseUrl 和 appId 供直接使用
export const baseUrl = currentConfig.baseUrl
export const appId = currentConfig.appId
